import RemoveOnCountry from './RemoveOnCountry.js';
import ShowOnAuthenticated from './ShowOnAuthenticated.js';
import ShowOnCountry from './ShowOnCountry.js';

/**
 * Register directives globally to let import this module without duplicating registration for each directive,
 * for each Vue app.
 */
const register = (v) => {
    v.directive('remove-on-country', RemoveOnCountry);
    v.directive('show-on-authenticated', ShowOnAuthenticated);
    v.directive('show-on-country', ShowOnCountry);
};
export default register;

export { RemoveOnCountry, ShowOnAuthenticated, ShowOnCountry };
